import React from "react";
import Immigration1 from "../../../assets/image/quebec.jpg";
import Immigration2 from "../../../assets/image/ontario.jpg";
import Immigration3 from "../../../assets/image/britishColumbia.jpg";
import Immigration4 from "../../../assets/image/alberta.jpg";
import { Link } from "react-router-dom";

const countries = [
    { id: 1, name: "Quebec", image: Immigration1 },
    { id: 2, name: "Ontario", image: Immigration2 },
    { id: 3, name: "British Columbia", image: Immigration3 },
    { id: 4, name: "Alberta", image: Immigration4 },
];

const ImmigrationCountries = () => {
    return (
        <section className="py-12 md:py-16 bg-white">
            <div className="max-w-7xl mx-auto px-4">

                {/* Heading */}
                <div className="text-center mb-10 md:mb-12">
                    <p className="uppercase tracking-widest font-[600] text-[#777777] text-sm md:text-base">
                        Provinces We Support
                    </p>

                    <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-black capitalize leading-tight my-6 px-4 sm:px-10 lg:px-20">
                        We provide immigration and file management assistance for:
                    </h2>

                    <div className="flex gap-2 justify-center items-center">
                        <div className="w-12 h-1 bg-[#ec4e4f] rounded"></div>
                        <div className="w-1 h-1 bg-[#ec4e4f] rounded"></div>
                        <div className="w-1 h-1 bg-[#ec4e4f] rounded"></div>
                        <div className="w-1 h-1 bg-[#ec4e4f] rounded"></div>
                    </div>
                </div>

                {/* Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
                    {countries.map((item) => (
                        <div
                            key={item.id}
                            className="relative h-56 sm:h-60 md:h-64 overflow-hidden group cursor-pointer"
                        >
                            <img
                                src={item.image}
                                alt={item.name}
                                className="w-full h-full object-cover transform group-hover:scale-110 transition duration-500"
                            />

                            {/* Overlay */}
                            <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                                <h3 className="text-white text-lg md:text-xl font-semibold">
                                    {item.name}
                                </h3>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Bottom Text */}
                <p className="text-center mt-10 md:mt-12 text-base sm:text-lg md:text-[26px] text-[#222222] cabin px-2">
                    Trinity is your trusted partner in achieving immigration and File Management.
                    <Link to="/contact-us" className="text-[#ec4e4f] font-semibold ml-2 hover:underline">
                        Get In Touch <span className="text-[#2d5883]">→</span>
                    </Link>
                </p>
            </div>
        </section>
    );
};

export default ImmigrationCountries;
